import * as React from "react";

import { Label as PrimitiveLabel } from "../../primitive/label";

export type LabelProps = React.ComponentProps<typeof PrimitiveLabel>;

export const Label = React.forwardRef<HTMLLabelElement, LabelProps>(
  (props, ref) => {
    return <PrimitiveLabel ref={ref} {...props} />;
  },
);

Label.displayName = "Label";
